import React from 'react';
import { withNavigation } from '../../Utils/Navigater';

const ShipmentPaymentResult = (props) => { 
    return <div> Payment has been made or failed </div>;
}

export default withNavigation(ShipmentPaymentResult);